module.exports = __webpack_public_path__ + "media/svg/st-bc4caef7.svg";